export class TopBar {
  private scene;

  constructor(scene, screenWidth) {
    this.scene = scene;
    const topBar = this.scene.add.sprite(screenWidth / 2, 100, 'topbar').setDepth(1);
    topBar.setDisplaySize(screenWidth, 200);
  }
}
